<template>
  <b-container>
    <b-row align-h="center" class="mt-5">

      <b-col lg="8" md="12" class="mb-5">
        <b-card-header class="card-main-header">
            <h3 class="text-center">Your Donations!</h3>
        </b-card-header>
        <b-card class="card-main p-3 text-center">

          <DonationsTable :user="user" ref="donationsTable"></DonationsTable>

        </b-card>
      </b-col>

      <b-col lg="4" md="12">
        <b-card-header class="card-main-header">
            <h3 class="text-center">Status</h3>
        </b-card-header>
        <b-card class="card-main p-3 text-center">

          <h1 class="text-center pb-3">{{ user.username }}</h1>

          <!-- <b-card-text>Your donation total:</b-card-text>
          <h1 class="text-center font-weight-light">
            <small class="dollar">$</small>{{ totalDonated }}
          </h1> -->

          <b-card-text>Your current rank:</b-card-text>
          <h1 class="text-center font-weight-light">{{ groupRank }}</h1>

          <b-card-text>Your expiration date:</b-card-text>
          <h1 class="text-center font-weight-light">{{ expirationDate }}</h1>

          <b-card-text>Your discord status:</b-card-text>
          <template v-if="user.discord_id != null">
            <a :href="discordLogoutURL" class="btn btn-lg btn-block discord-button">
              <img src="@/assets/img/discord/discord_logo_white.png" width="32">Disconnect
            </a>
          </template>
          <template v-else>
            <a :href="discordLoginURL" class="btn btn-lg btn-block discord-button">
              <img src="@/assets/img/discord/discord_logo_white.png" width="32">Connect
            </a>
          </template>

        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import moment from 'moment'
import UserApi from '@/services/UserApi'
import EventBus from '@/services/EventBus'

const DonationsTable = () => import(
  './Tables/Donations.vue'
);

export default {
  async created() {
    UserApi.getUserData().then((user) => {
      this.user = user;
    }).catch(error => {
      EventBus.$emit('Error', error);
    });
  },
  data() {
    return {
      user: [],
      discordLoginURL: process.env.API_URL + '/api/auth/discord',
      discordLogoutURL: process.env.API_URL + '/api/auth/discord/logout',
    }
  },
  computed: {
    // totalDonated: function () {
    //   let sum = 0;
    //   this.donations.forEach(function(donation) {
    //      sum += parseFloat(donation.amount);
    //   });

    //   return sum;
    // },
    expirationDate: function () {
      if(this.user == undefined || this.user.expiration_date == null && !this.user.permanent) {
        return 'None';
      } if(this.user.permanent) {
        return 'Permanent';
      } else if(moment(this.user.expiration_date).isBefore(new Date())) {
        return 'Expired'
      } else {
        return moment(this.user.expiration_date).fromNow();
      }
    },
    groupRank: function () {
      if(this.user.plan == undefined || this.user.plan_id == 0 || moment().isAfter(this.user.expiration_date)) {
        return 'None';
      } else {
        return this.user.plan.name;
      }
    }
  },
  methods: {
    toggleLoading() {
      this.isLoading = !this.isLoading;
    }
  },
  components: {
    'DonationsTable': DonationsTable,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue